import BootstrapGrid from "./views/BootstrapGrid/BootstrapGrid.vue";
import CssGrid from "./views/CssGrid/CssGrid.vue";
import PrintGrid from "./views/PrintGrid/PrintGrid.vue";

// import BuyQuoteEditForm from "@/components/BuyQuotes/BuyQuoteEditForm.vue";
// import CalendarFeedCreate from "@/components/CalendarFeeds/CalendarFeedCreate.vue";
// import GrindingLoads from "@/components/GrindingLoads/GrindingLoads.vue";
// import GrindingLoadEditForm from "@/components/GrindingLoads/GrindingLoadEditForm.vue";
// import TemplateWorkOrderLotEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderLotEditForm.vue";
// import TemplateWorkOrderLots from "@/components/TemplateWorkOrders/TemplateWorkOrderLots.vue";
// import TemplateWorkOrderShow from "@/components/TemplateWorkOrders/TemplateWorkOrderShow.vue";
// import TemplateWorkOrderTaskEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderTaskEditForm.vue";
// import TemplateWorkOrderTaskLineItemEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderTaskLineItemEditForm.vue";
// import TemplateWorkOrderTasks from "@/components/TemplateWorkOrders/TemplateWorkOrderTasks.vue";
import Vue from "vue";
import VueRouter from "vue-router";
// import WorkOrderAttachmentEditForm from "@/components/WorkOrders/WorkOrderAttachmentEditForm.vue";
// import WorkOrderAttachments from "@/components/WorkOrders/WorkOrderAttachments.vue";
// import WorkOrderLotEditForm from "@/components/WorkOrders/WorkOrderLotEditForm.vue";
// import WorkOrderLots from "@/components/WorkOrders/WorkOrderLots.vue";

// needed to check if user is logged in
import store from "./store/index";

Vue.use(VueRouter);

const allPermissionLevels = ["admin", "field_worker", "office_worker"];
const noFieldWorker = ["admin", "office_worker"];

export const enum NamedRts {
  billingDashboard = "billingDashboard",
  productivityDashboard = "productivityDashboard",
  calendarSchedule = "calendarSchedule",

  templateWorkOrders = "templateWorkOrders",
  templateWorkOrderEditForm = "templateWorkOrderEditForm",
  templateWorkOrderBuildForm = "templateWorkOrderBuildForm",

  buildWorkOrder = "buildWorkOrder",
  workOrders = "workOrders",
  workOrderShow = "workOrderShow",
  workOrderEditForm = "workOrderEditForm",
  workOrderCreateForm = "workOrderCreateForm",
  workOrderTasks = "workOrderTasks",
  workOrderPrint = "workOrderPrint",
  workOrderDetails = "workOrderDetails",
  workOrderInstructions = "workOrderInstructions",
  workOrderInstructionEditForm = "workOrderInstructionEditForm",

  sellContracts = "sellContracts",
  sellContractEditForm = "sellContractEditForm",
  sellContractShow = "sellContractShow",
  sellContractDetails = "sellContractDetails",
  sellContractIlsctlLineItems = "sellContractIlsctlLineItems",
  sellContractPrint = "sellContractPrint",

  inventoryLots = "inventoryLots",
  inventoryLotEditForm = "inventoryLotEditForm",
  inventoryLotShow = "inventoryLotShow",
  inventoryLotDetails = "inventoryLotDetails",
  inventoryLotIlsctlLineItems = "inventoryLotIlsctlLineItems",
  inventoryLotPrint = "inventoryLotPrint",

  clientFields = "clientFields",
  clientFieldEditForm = "clientFieldEditForm",
  clientFieldShow = "clientFieldShow",

  commodityInventorySummaries = "commodityInventorySummaries",
  commodityInventorySummaryShow = "commodityInventorySummaryShow",

  trucks = "trucks",
  truckEditForm = "truckEditForm",

  truckLoads = "truckLoads",
  buildTruckLoad = "buildTruckLoad",

  truckLoadReports = "truckLoadReports",

  clients = "clients",
  clientShow = "clientShow",
  clientEditForm = "clientEditForm",

  users = "users",
  userEditForm = "userEditForm",

  lotUnits = "lotUnits",
  lotUnitEditForm = "lotUnitEditForm",

  lineItems = "lineItems",
  lineItemEditForm = "lineItemEditForm",

  commodities = "commodities",
  commodityEditForm = "commodityEditForm",

  workQueue = "workQueue",

  // these are the mobile routes that are optimized for mobile use
  mWorkQueue = "mWorkQueue",
  mWorkOrderShow = "mWorkOrderShow",
  mWorkOrderTasks = "mWorkOrderTasks",
  mWorkOrders = "mWorkOrders",
  mWorkOrderNotes = "mWorkOrderNotes",

  mLogIn = "mLogIn",
}

const idNameFinder = {
  [NamedRts.billingDashboard]: "id",
  [NamedRts.productivityDashboard]: "id",
  [NamedRts.calendarSchedule]: "id",

  [NamedRts.templateWorkOrders]: "templateWorkOrderId",
  [NamedRts.templateWorkOrderEditForm]: "templateWorkOrderId",
  [NamedRts.templateWorkOrderBuildForm]: "templateWorkOrderId",

  [NamedRts.buildWorkOrder]: "workOrderId",
  [NamedRts.workOrders]: "workOrderId",
  [NamedRts.workOrderShow]: "workOrderId",
  [NamedRts.workOrderEditForm]: "workOrderId",
  [NamedRts.workOrderCreateForm]: "workOrderId",
  [NamedRts.workOrderTasks]: "workOrderId",
  [NamedRts.workOrderPrint]: "workOrderId",
  [NamedRts.workOrderDetails]: "workOrderId",
  [NamedRts.workOrderInstructions]: "workOrderId",
  [NamedRts.workOrderInstructionEditForm]: "workOrderInstructionId",

  [NamedRts.inventoryLotShow]: "inventoryLotId",
  [NamedRts.inventoryLotEditForm]: "inventoryLotId",
  [NamedRts.inventoryLots]: "inventoryLotId",
  [NamedRts.inventoryLotDetails]: "inventoryLotId",
  [NamedRts.inventoryLotIlsctlLineItems]: "inventoryLotId",
  [NamedRts.inventoryLotPrint]: "inventoryLotId",

  [NamedRts.clientFieldShow]: "clientFieldId",
  [NamedRts.clientFieldEditForm]: "clientFieldId",
  [NamedRts.clientFields]: "clientFieldId",

  [NamedRts.sellContractShow]: "sellContractId",
  [NamedRts.sellContracts]: "sellContractId",
  [NamedRts.sellContractEditForm]: "sellContractId",
  [NamedRts.sellContractDetails]: "sellContractId",
  [NamedRts.sellContractIlsctlLineItems]: "sellContractId",
  [NamedRts.sellContractPrint]: "sellContractId",

  [NamedRts.trucks]: "truckId",
  [NamedRts.truckEditForm]: "truckId",

  [NamedRts.truckLoads]: "truckLoadId",
  [NamedRts.buildTruckLoad]: "truckLoadId",

  [NamedRts.truckLoadReports]: "truckLoadId",

  [NamedRts.commodityInventorySummaries]: "commodityId",
  [NamedRts.commodityInventorySummaryShow]: "commodityId",

  [NamedRts.clients]: "clientId",
  [NamedRts.clientShow]: "clientId",
  [NamedRts.clientEditForm]: "clientId",

  [NamedRts.users]: "userId",
  [NamedRts.userEditForm]: "userId",

  [NamedRts.lotUnits]: "lotUnitId",
  [NamedRts.lotUnitEditForm]: "lotUnitId",

  [NamedRts.lineItems]: "lineItemId",
  [NamedRts.lineItemEditForm]: "lineItemId",

  [NamedRts.commodities]: "commodityId",
  [NamedRts.commodityEditForm]: "commodityId",

  [NamedRts.workQueue]: "id",

  [NamedRts.mWorkOrderShow]: "workOrderId",
  [NamedRts.mWorkOrderTasks]: "workOrderId",
  [NamedRts.mWorkOrderNotes]: "workOrderId",
  [NamedRts.mWorkOrders]: "workOrderId",

  [NamedRts.mWorkQueue]: "id",
  [NamedRts.mLogIn]: "id",
};

export function itemRouteBuilder(rtName: NamedRts, id: string) {
  let paramId = "id";
  paramId = idNameFinder[rtName];

  return {
    name: rtName,
    params: {
      [paramId]: id,
    },
  };
}

let router = new VueRouter({
  routes: [
    {
      path: "/",
      redirect: { name: NamedRts.mLogIn },
    },
    {
      path: "/m",
      name: "mGrid",
      component: () =>
        import(/* webpackChunkName: "mgridview" */ "@/views/MGrid/MGrid.vue"),
      meta: {
        requiresAuth: false,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        {
          path: "/log-in",
          name: NamedRts.mLogIn,
          component: () =>
            import(
              /* webpackChunkName: "mgridview" */ "@/components/Session/LogIn.vue"
            ),
          meta: {
            requiresAuth: false,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "work-queue",
          name: NamedRts.mWorkQueue,
          component: () =>
            import(
              /* webpackChunkName: "mgridview" */ "@/components/WorkQueue/MWorkQueue.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "work-orders",
          name: NamedRts.mWorkOrders,
          component: () =>
            import(
              /* webpackChunkName: "mgridview" */ "@/components/FWWorkOrders/MWorkOrders.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "work-order-show/:workOrderId",
          name: NamedRts.mWorkOrderShow,
          component: () =>
            import(
              /* webpackChunkName: "mgridview" */ "@/components/FWWorkOrders/MWorkOrderShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
          children: [
            {
              path: "tasks",
              name: NamedRts.mWorkOrderTasks,
              component: () =>
                import(
                  /* webpackChunkName: "mgridview" */ "@/components/FWWorkOrders/MWorkOrderTasks.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: allPermissionLevels,
              },
            },
            {
              path: "notes",
              name: NamedRts.mWorkOrderNotes,
              component: () =>
                import(
                  /* webpackChunkName: "mgridview" */ "@/components/FWWorkOrders/MWorkOrderNotes.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: allPermissionLevels,
              },
            },
          ],
        },
      ],
    },
    {
      path: "/print-grid",
      name: "printGrid",
      component: PrintGrid,
      meta: {
        requiresAuth: false,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        {
          path: "/print-work-order/:workOrderId",
          name: NamedRts.workOrderPrint,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderPrint.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/print-inventory-lot/:inventoryLotId",
          name: NamedRts.inventoryLotPrint,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/InventoryLots/InventoryLotPrint.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/print-sell-contract/:sellContractId",
          name: NamedRts.sellContractPrint,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/SellContracts/SellContractPrint.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
      ],
    },
    {
      path: "/css-grid",
      name: "cssGrid",
      component: CssGrid,
      meta: {
        requiresAuth: false,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        {
          path: "/calendar",
          name: NamedRts.calendarSchedule,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Schedule/Calendar.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/truck-load-reports",
          name: NamedRts.truckLoadReports,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/TruckLoadReports/TruckLoadReport.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/productivity-dashboard",
          name: NamedRts.productivityDashboard,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/ProductivityDashboard/ProductivityDashboard.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/trucks",
          name: NamedRts.trucks,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/Trucks/Trucks.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/truck-edit/:truckId",
          name: NamedRts.truckEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/Trucks/TruckEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/template-work-order-edit/:templateWorkOrderId",
          name: NamedRts.templateWorkOrderEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/TemplateWorkOrders/TemplateWorkOrderEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "/template-work-order-build/:templateWorkOrderId",
          name: NamedRts.templateWorkOrderBuildForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/TemplateWorkOrders/TemplateWorkOrderBuildForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "/template-work-orders",
          name: NamedRts.templateWorkOrders,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/TemplateWorkOrders/TemplateWorkOrders.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/create-work-order",
          name: NamedRts.workOrderCreateForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/CreateWorkOrderForm.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/work-order-edit/:workOrderId",
          name: NamedRts.workOrderEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/work-order-show/:workOrderId",
          name: NamedRts.workOrderShow,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
          children: [
            {
              path: "tasks",
              name: NamedRts.workOrderTasks,
              component: () =>
                import(
                  /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderTasks.vue"
                ),
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },

            {
              path: "details",
              name: NamedRts.workOrderDetails,
              component: () =>
                import(
                  /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderDetails.vue"
                ),
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },

            {
              path: "instructions",
              name: NamedRts.workOrderInstructions,
              component: () =>
                import(
                  /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderInstructions.vue"
                ),
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },

            {
              path: "instruction-edit/:workOrderInstructionId",
              name: NamedRts.workOrderInstructionEditForm,
              component: () =>
                import(
                  /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrderInstructionEditForm.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },
          ],
        },
        {
          path: "/work-orders",
          name: NamedRts.workOrders,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/WorkOrders.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/build-work-order/:workOrderId",
          name: NamedRts.buildWorkOrder,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkOrders/BuildWorkOrder.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/billing-dashboard",
          name: NamedRts.billingDashboard,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/BillingDashboard/BillingDashboard.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/client-fields",
          name: NamedRts.clientFields,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/ClientFields/ClientFields.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/client-field-show/:clientFieldId",
          name: NamedRts.clientFieldShow,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/ClientFields/ClientFieldShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/client-field-edit/:clientFieldId",
          name: NamedRts.clientFieldEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/ClientFields/ClientFieldEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/line-items",
          name: NamedRts.lineItems,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/LineItems/LineItems.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/line-item-edit/:lineItemId",
          name: NamedRts.lineItemEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/LineItems/LineItemEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/lot-units",
          name: NamedRts.lotUnits,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/LotUnits/LotUnits.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/lot-unit-edit/:lotUnitId",
          name: NamedRts.lotUnitEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/LotUnits/LotUnitEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/commodity-edit/:commodityId",
          name: NamedRts.commodityEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Commodities/CommodityEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/commodities",
          name: NamedRts.commodities,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Commodities/Commodities.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/users",
          name: NamedRts.users,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Users/Users.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/user-edit/:userId",
          name: NamedRts.userEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Users/UserEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/clients",
          name: NamedRts.clients,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Clients/Clients.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/client-show/:clientId",
          name: NamedRts.clientShow,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Clients/ClientShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/client-edit/:clientId",
          name: NamedRts.clientEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/Clients/ClientEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/work-queue",
          name: "workQueue",
          component: () =>
            import(
              /* webpackChunkName: "dgridview" */ "@/components/WorkQueue/WorkQueue.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/commodity-inventory-summaries",
          name: NamedRts.commodityInventorySummaries,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/CommodityInventorySummaries/CommodityInventorySummaries.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/commodity-inventory-summary-show/:commodityId",
          name: NamedRts.commodityInventorySummaryShow,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/CommodityInventorySummaries/CommodityInventorySummaryShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/sell-contracts",
          name: NamedRts.sellContracts,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/SellContracts/SellContracts.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/sell-contract-show/:sellContractId",
          name: NamedRts.sellContractShow,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/SellContracts/SellContractShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
          children: [
            {
              path: "details",
              name: NamedRts.sellContractDetails,
              component: () =>
                import(
                  /* webpackChunkName: "dBroker" */ "@/components/SellContracts/SellContractDetails.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },
            {
              path: "ilsctl-line-items",
              name: NamedRts.sellContractIlsctlLineItems,
              component: () =>
                import(
                  /* webpackChunkName: "dBroker" */ "@/components/SellContracts/SellContractIlsctlLineItems.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },
          ],
        },
        {
          path: "/sell-contract-edit/:sellContractId",
          name: NamedRts.sellContractEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/SellContracts/SellContractEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/truck-loads",
          name: NamedRts.truckLoads,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/TruckLoads/TruckLoads.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/build-truck-load/:truckLoadId",
          name: NamedRts.buildTruckLoad,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/TruckLoads/BuildTruckLoad.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/inventory-lots",
          name: NamedRts.inventoryLots,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/InventoryLots/InventoryLots.vue"
            ),
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
        {
          path: "/inventory-lot-show/:inventoryLotId",
          name: NamedRts.inventoryLotShow,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/InventoryLots/InventoryLotShow.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
          children: [
            {
              path: "details",
              name: NamedRts.inventoryLotDetails,
              component: () =>
                import(
                  /* webpackChunkName: "dBroker" */ "@/components/InventoryLots/InventoryLotDetails.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },
            {
              path: "ilsctl-line-items",
              name: NamedRts.inventoryLotIlsctlLineItems,
              component: () =>
                import(
                  /* webpackChunkName: "dBroker" */ "@/components/InventoryLots/InventoryLotIlsctlLineItems.vue"
                ),
              props: true,
              meta: {
                requiresAuth: true,
                allowedPermissionLevels: noFieldWorker,
              },
            },
          ],
        },
        {
          path: "/inventory-lot-edit/:inventoryLotId",
          name: NamedRts.inventoryLotEditForm,
          component: () =>
            import(
              /* webpackChunkName: "dBroker" */ "@/components/InventoryLots/InventoryLotEditForm.vue"
            ),
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: noFieldWorker,
          },
        },
      ],
    },
    {
      path: "/bootstrap-grid",
      component: BootstrapGrid,
      meta: {
        requiresAuth: false,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        // {
        //   path: "/buy-quote-edit/:buyQuoteId",
        //   name: "buyQuoteEditForm",
        //   component: BuyQuoteEditForm,
        //   props: true,
        //   meta: {
        //     requiresAuth: true,
        //     allowedPermissionLevels: allPermissionLevels,
        //   },
        // },
        // {
        //   path: "/calendar-feed",
        //   name: "calendarFeedCreate",
        //   component: CalendarFeedCreate,
        //   meta: {
        //     requiresAuth: true,
        //     allowedPermissionLevels: allPermissionLevels,
        //   },
        // },
        // {
        //   path: "/grinding-loads",
        //   name: "grindingLoads",
        //   component: GrindingLoads,
        //   meta: {
        //     requiresAuth: true,
        //     allowedPermissionLevels: allPermissionLevels,
        //   },
        // },
        // {
        //   path: "/grinding-load-edit/:grindingLoadId",
        //   name: "grindingLoadEditForm",
        //   component: GrindingLoadEditForm,
        //   props: true,
        //   meta: {
        //     requiresAuth: true,
        //     allowedPermissionLevels: allPermissionLevels,
        //   },
        // },
        // {
        //   path: "/work-order-show/:workOrderId",
        //   name: "workOrderShow",
        //   component: WorkOrderShow,
        //   props: true,
        //   meta: {
        //     requiresAuth: true,
        //     allowedPermissionLevels: allPermissionLevels,
        //   },
        //   children: [
        //     {
        //       path: "lots",
        //       name: "workOrderLots",
        //       component: WorkOrderLots,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "attachments",
        //       name: "workOrderAttachments",
        //       component: WorkOrderAttachments,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "attachment-edit/:workOrderAttachmentId",
        //       name: "workOrderAttachmentEditForm",
        //       component: WorkOrderAttachmentEditForm,
        //       props: true,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "lot-edit/:workOrderLotId",
        //       name: "workOrderLotEditForm",
        //       component: WorkOrderLotEditForm,
        //       props: true,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //   ],
        // },
        // {
        //   path: "/template-work-order-show/:templateWorkOrderId",
        //   name: "templateWorkOrderShow",
        //   component: TemplateWorkOrderShow,
        //   props: true,
        //   meta: {
        //     requiresAuth: true,
        //     allowedPermissionLevels: allPermissionLevels,
        //   },
        //   children: [
        //     {
        //       path: "lots",
        //       name: "templateWorkOrderLots",
        //       component: TemplateWorkOrderLots,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "lot-edit/:templateWorkOrderLotId",
        //       name: "templateWorkOrderLotEditForm",
        //       component: TemplateWorkOrderLotEditForm,
        //       props: true,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "tasks",
        //       name: "templateWorkOrderTasks",
        //       component: TemplateWorkOrderTasks,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "task/:taskId/line-item-edit/:lineItemId",
        //       name: "templateWorkOrderTaskLineItemEditForm",
        //       component: TemplateWorkOrderTaskLineItemEditForm,
        //       props: true,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //     {
        //       path: "task-edit/:templateWorkOrderTaskId",
        //       name: "templateWorkOrderTaskEditForm",
        //       component: TemplateWorkOrderTaskEditForm,
        //       props: true,
        //       meta: {
        //         requiresAuth: true,
        //         allowedPermissionLevels: allPermissionLevels,
        //       },
        //     },
        //   ],
        // },
        // {
        //   path: "/about",
        //   name: "about",
        //   // route level code-splitting
        //   // this generates a separate chunk (about.[hash].js) for this route
        //   // which is lazy-loaded when the route is visited.
        //   component: () =>
        //     import(/* webpackChunkName: "about" */ "./views/About.vue"),
        // },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  let passedLogInCheck = false;
  let passedPermissionLevelCheck = false;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      // passed it and has it
      passedLogInCheck = true;
    } else {
      // needs auth, doesn't have it
      // store the route in the store
      store.dispatch("updateNextPath", to.path);
      passedLogInCheck = false;

      next({
        name: NamedRts.mLogIn,
        params: {
          nextUrl: to.fullPath,
        },
      });
      return;
    }
  } else {
    // doesn't need auth
    passedLogInCheck = true;
  }

  const permissionLevel = store.getters.userPermissionLevel;

  if (
    to.matched.every(record => {
      return record.meta.allowedPermissionLevels.includes(permissionLevel);
    })
  ) {
    passedPermissionLevelCheck = true;
  } else {
    passedPermissionLevelCheck = false;
  }

  if (passedLogInCheck && passedPermissionLevelCheck) {
    // navigate
    next();
  }
});

export default router;
